interface LinkItem {
  key: string
  text: string
}
interface LinkSectionProps {
  title: string
  href: string
}
const LinkSection = ({ title, href }: LinkSectionProps) => {
  return (
    <div className="text-start md:text-center">
      <a
        href={href}
        className="block text-base md:text-md font-medium text-blue-400 dark:text-gray-300"
      >
        {title}
      </a>
    </div>
    // <div className="text-start md:text-center">
    //   <p className="text-base md:text-lg font-medium text-blue-400 dark:text-gray-300">
    //     {title}
    //   </p>
    //   <ul className="mt-5 flex flex-col gap-2">
    //     {links.map((link) => (
    //       <li
    //         key={link.key}
    //         className="text-[#AAACAF] text-base md:text-lg leading-[23.46px]"
    //       >
    //         {link.text}
    //       </li>
    //     ))}
    //   </ul>
    // </div>
  )
}

export default LinkSection
